import { Observable, Subject } from 'rxjs';

export interface IImplicitContext<T> {
  $implicit?: T;
}

export const POPUP_NODE_CLASS = 'popup-container-node';

export type PopupOnAction = () => any;

export interface IPopupButton {
  text: string;
  buttonClasses?: string;
  onAction?: PopupOnAction;
}

export interface IPopupOptions {
  width?: string;
  popupClass?: string;
  showTitle?: boolean;
  showMessage?: boolean;
  showCloseBtn?: boolean;
  injectComponent?: any;
  actionButtons?: IPopupButton[];
  animate?: string;
  position?: string;
  showOverlay?: boolean;
  closeOnOverlay?: boolean;
  callback?: Function;
}
